<script setup lang="ts">
defineProps<{
  label: string
  hint?: string
  error?: string
  required?: boolean
}>()
</script>

<template>
  <label class="block">
    <span class="mb-1.5 flex items-baseline gap-1.5">
      <span class="text-[13px] font-medium text-muted">{{ label }}</span>
      <span v-if="required" class="text-[12px] text-accent">*</span>
      <span v-if="hint" class="text-[12px] font-normal text-dim">{{ hint }}</span>
    </span>
    <slot />
    <span v-if="error" class="mt-1 block text-[12px] text-danger">{{ error }}</span>
  </label>
</template>
